const DEFAULT_EXTENSIONS = [
    '.pdf',
    '.mp3', '.wav', '.m4a', '.ogg', '.flac', '.aac',
    '.mp4', '.webm', '.mov',
    '.jpg', '.jpeg', '.png', '.gif', '.webp',
    '.docx',
    '.txt',
];

export function getAllowedUploadExtensions() {
    const raw = process.env.REACT_APP_SOURCES_ALLOWED_UPLOAD_EXTENSIONS;
    if (!raw || !String(raw).trim()) {
        return DEFAULT_EXTENSIONS;
    }
    return String(raw)
        .split(',')
        .map((part) => part.trim().toLowerCase())
        .filter(Boolean)
        .map((ext) => (ext.startsWith('.') ? ext : `.${ext}`));
}

export function buildUploadAcceptAttribute() {
    const exts = getAllowedUploadExtensions();
    const mimeHints = ['application/pdf', 'image/*', 'video/*', 'audio/*'];
    return [...mimeHints, ...exts].join(',');
}

export function isAllowedUploadFile(file) {
    if (!file?.name) {
        return false;
    }
    const name = String(file.name).trim().toLowerCase();
    const dot = name.lastIndexOf('.');
    if (dot < 0) {
        return false;
    }
    const ext = name.slice(dot);
    return getAllowedUploadExtensions().includes(ext);
}
